import React from 'react';

import { ModalDefault } from '../../../../components/ModalDefault/ModalDefault';
import { pushNotify } from 'components/Notifications';
import { useResolveSupportDisputeMutation } from '../../../../redux/services/SupportApi';
import { type SupportOrder } from '../../../../redux/types/SupportTypes';
import { errorText, formatMoney, orderAmount } from '../helpers';
import styles from '../Support.module.css';

type Props = { order: SupportOrder; decision: 'approve' | 'reject'; onClose: () => void };

// Confirms the trader's decision on a dispute: approve → FINISHED_WITH_RECALCULATION, reject → CANCELED_WITH_RECALCULATION.
export const ResolveModal: React.FC<Props> = ({ order, decision, onClose }) => {
  const [resolve, { isLoading }] = useResolveSupportDisputeMutation();
  const approve = decision === 'approve';

  const submit = async () => {
    try {
      await resolve({ id: order.id, decision }).unwrap();
      onClose();
    } catch (error) {
      pushNotify(errorText(error, 'Не удалось закрыть спор'), 'Ошибка');
    }
  };

  return (
    <ModalDefault title={approve ? 'Подтвердить спор от лица трейдера' : 'Отклонить спор от лица трейдера'} active setActive={(value) => !value && onClose()}>
      <div className={styles.form}>
        <div className={styles.muted}>
          Заявка {order.id}
          <br />
          Трейдер {order.trader} · мерчант {order.merchant}
        </div>
        <p>
          {approve
            ? `Заявка будет закрыта с перерасчётом на ${formatMoney(orderAmount(order))} ${order.currency_code_to}: трейдеру зачислится доход, мерчант получит callback.`
            : 'Перерасчёт будет отклонён: заявка закроется как отказ по спору.'}
        </p>
        <div className={styles.formButtons}>
          <button type='button' className={styles.actionButton} onClick={onClose} disabled={isLoading}>
            Отмена
          </button>
          <button
            type='button'
            className={`${styles.actionButton} ${approve ? '' : styles.danger}`}
            onClick={submit}
            disabled={isLoading}
          >
            {isLoading ? 'Отправляем…' : approve ? 'Подтвердить' : 'Отклонить'}
          </button>
        </div>
      </div>
    </ModalDefault>
  );
};
